import styled from 'styled-components';

export const TimerWrapper = styled.div`
	margin-top: 8px;
	display: flex;
	width: 320px;
	padding: 9px 17px;
	align-items: center;
	justify-content: center;
	gap: 22px;
	border-radius: 8px;
	background: #ff4b55;

	color: #fff;
	font-family: 'Work Sans';
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 39.2px */

	@media (min-width: 600px) {
		width: 650px;
	}
`;

export const TextTimer = styled.div`
	color: #fff;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 16.8px */
	max-width: 160px;
`;
